import React from 'react'

import { useSelector } from 'react-redux'

import { IApplicationState } from '@store'
import {
  selectIsFetchingSubmissionsByIdentity,
  selectSubmissionsByIdentity,
} from '@store/brandFans'
import { isEmpty } from '@utils'
import InfluencerIdentityRowSubmissionEmpty from './Empty'
import InfluencerIdentityRowSubmissionsList from './List'
import InfluencerIdentityRowSubmissionsLoading from './Loading'

interface IProps {
  identityId: number
}

export const InfluencerIdentityRowSubmissionWrapper: React.FC<IProps> = ({ identityId }) => {
  const isFetching = useSelector((state: IApplicationState) =>
    selectIsFetchingSubmissionsByIdentity(state, identityId),
  )
  const isSubmissionsEmpty = useSelector((state: IApplicationState) =>
    isEmpty(selectSubmissionsByIdentity(state, identityId)),
  )

  if (isFetching) {
    return <InfluencerIdentityRowSubmissionsLoading />
  }
  if (isSubmissionsEmpty) {
    return <InfluencerIdentityRowSubmissionEmpty />
  }
  return <InfluencerIdentityRowSubmissionsList identityId={identityId} />
}

export default InfluencerIdentityRowSubmissionWrapper
